import { render, staticRenderFns } from "./ChatFeedback.vue?vue&type=template&id=09c7b5e8&scoped=true&"
import script from "./ChatFeedback.vue?vue&type=script&lang=js&"
export * from "./ChatFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ChatFeedback.vue?vue&type=style&index=0&id=09c7b5e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7b5e8",
  null
  
)

export default component.exports